import styleFn, {compose} from '../util.js'

const properties = {
  m: 'margin',
  p: 'padding'
}

const directions = {
  t: 'top',
  b: 'bottom',
  l: 'left',
  r: 'right',
  x: ['left', 'right'],
  y: ['top', 'bottom']
}

const hypenate = (...strings) => strings.join('-')

function getCssProperty(propName) {
  const [prop, dir] = propName
  const property = properties[prop]
  const direction = directions[dir]

  if (!direction) {
    return property
  }

  if (Array.isArray(direction)) {
    return direction.map(dir => hypenate(property, dir))
  }

  return hypenate(property, direction)
}

const getStyle = propName => styleFn({
  propName,
  systemProp: 'space',
  cssProp: getCssProperty(propName)
})

const noop = () => null
const PROP = /^[mp][tblrxy]?$/
const styles = (a, b) => compose(a, b)

function space(props) {
  return Object.keys(props)
    .filter(key => PROP.test(key))
    .sort()
    .map(getStyle)
    .reduce(styles, noop)
}

export default space
